/**
 * A role is an authorization fact, while membership is a billing fact. An
 * administrator must never be required to buy a membership to review the member
 * experience or access member-only content. Keep that distinction in one shared
 * predicate so server responses and client promotional surfaces agree.
 */
export function hasFullSiteAccess(input: {
  role?: string | null;
  membership?: "free" | "premium" | null;
  accessState?: string | null;
}): boolean {
  return input.role === "admin" || input.membership === "premium" || input.accessState === "active";
}

export function directoryViewerAccess(input: {
  role?: string | null;
  accessState?: string | null;
}): "paid" | "basic" {
  return hasFullSiteAccess(input) ? "paid" : "basic";
}
